module.exports = __webpack_public_path__ + "img/pack.399e807c.svg";